import React, { useRef } from "react";
import Textfield from "./Textfield";
import Datepicker from "./Datepicker";

export default function Date({
  value,
  placeholder,
  onChange,
}) {
  const textfield = useRef(null);
  const datepicker = useRef(null);

  // Toggle
  function open() {
    datepicker.current.style.display = 'block';
  }

  function close() {
    datepicker.current.style.display = 'none';
  }

  return (
    <div className="ds-date">
      <Textfield
        ref={textfield}
        icon="calendar"
        placeholder={placeholder}
        value={value || ''}
        onfocus={open}
        onblur={close}
        readOnly={true}
      />

      <Datepicker ref={datepicker} onchange={onChange} />
    </div>
  )
}
